import React, { useState } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import CustomerBank from "./CustomerBank";

interface BanksTableProps {
  banks: any;
  setOpenBank: React.Dispatch<React.SetStateAction<boolean>>;
}

const BanksTable: React.FC<BanksTableProps> = ({ banks, setOpenBank }) => {
  const [cBank, setCBank] = useState(false);
  const [getUserId, setUserId] = useState<string>("");

  const handleModal = (id: string) => {
    setCBank(!cBank);
    setUserId(id);
  };

  // Flatten and aggregate the data structure
  const flattenedBankProducts = banks?.customerAccount?.flatMap((bank: any) =>
    bank?.product?.map((product: any) => ({
      bankName: bank.bank.bankName,
      productName: product.name,
      amount: bank.balance.amount,
      quantity: bank.balance.quantity,
    }))
  );

  // Group by bankName and productName
  const groupedBankProducts = flattenedBankProducts.reduce((acc: any, item: any) => {
    const key = `${item.bankName}-${item.productName}`;
    if (!acc[key]) {
      acc[key] = { ...item, quantity: 0 };
    }
    acc[key].quantity += item.quantity;
    return acc;
  }, {});

  // Convert grouped data back to array
  const aggregatedBankProducts = Object.values(groupedBankProducts).map((item: any) => ({
    bankName: item.bankName,
    productName: item.productName,
    amount: item.amount, // Keep amount separate, don't sum it
    quantity: item.quantity.toFixed(2),
  }));

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Banks</h4>
          <ImCancelCircle
            className="catCancel"
            onClick={() => setOpenBank(false)}
          />
        </div>
        <div className="line"></div>
        <div className="invoiceTable mb-20">
          <table className="inTable">
            <thead>
              <tr className="heTable text-lg">
                <th className="sn">SN</th>
                <th>Bank</th>
                <th>Product</th>
                <th>Amount(₦)</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {aggregatedBankProducts && aggregatedBankProducts.length > 0 ? (
                aggregatedBankProducts.map((bankProduct: any, index: number) => (
                  <tr className="taData" key={index}>
                    <td className="sn">{index + 1}</td>
                    <td>{bankProduct.bankName}</td>
                    <td>{bankProduct.productName}</td>
                    <td>₦{bankProduct.amount}</td>
                    <td>{bankProduct.quantity}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    No bank accounts available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {/* <div className="crBtn">
            <button onClick={() => handleModal(banks._id)}>
              Create New bank
            </button>
          </div> */}
          {cBank ? (
            <CustomerBank cusID={getUserId} getUserId={getUserId} setCBank={setCBank} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BanksTable;
